import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import LayerExpPanel from './LayerExpPanel';

const styles = theme => ({
  wrapper: {
    [theme.breakpoints.down('sm')]: {
      height: '35%',
      width: '100%',
      bottom: '0',
      top: 'auto',
      borderLeft: `1px solid ${theme.palette.primary.neutral}`,
      position: 'absolute',
      background: 'white',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
      overflow: 'auto'
    },
    height: '380px',
    width: '350px',
    top: '20px',
    borderLeft: `1px solid ${theme.palette.primary.neutral}`,
    position: 'absolute',
    background: 'white',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingTop: '10px'
  },
  title: {
    fontSize: theme.typography.pxToRem(14),
    fontFamily: 'Roboto',
    color: theme.palette.primary.darkNeutral,
    fontWeight: 500,
    padding: '5px 20px'
  }
});

export class LeftPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: ''
    };
  }

  handleExpand = panel => () => {
    if (this.state.expanded !== panel) {
      this.setState({
        expanded: panel
      });
    } else if (this.state.expanded === panel) {
      this.setState({
        expanded: ''
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { layers } = this.props;

    return (
      <div className={classes.wrapper}>
          <div className={classes.header}>
            <Typography classes={{ root: classes.title}}>Select Map Layer(s):</Typography>
        </div>
        <div>
          {layers.map(layerId => {
            return (
              <div onClick={this.handleExpand(layerId)} key={layerId + 2}>
                <LayerExpPanel
                  layerId={layerId}
                  key={layerId}
                  expanded={this.state.expanded === layerId}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mapview: { layers } }) => ({
  layers
});

const mapDispatchToProps = dispatch => ({
  // storeNextTimes: times => {
  //   dispatch(storeNextTimes(times));
  // }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(LeftPanel));
